"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDigestPaginationMetaDto = instanceOfDigestPaginationMetaDto;
exports.DigestPaginationMetaDtoFromJSON = DigestPaginationMetaDtoFromJSON;
exports.DigestPaginationMetaDtoFromJSONTyped = DigestPaginationMetaDtoFromJSONTyped;
exports.DigestPaginationMetaDtoToJSON = DigestPaginationMetaDtoToJSON;
exports.DigestPaginationMetaDtoToJSONTyped = DigestPaginationMetaDtoToJSONTyped;
/**
 * Check if a given object implements the DigestPaginationMetaDto interface.
 */
function instanceOfDigestPaginationMetaDto(value) {
    if (!('pageNo' in value) || value['pageNo'] === undefined)
        return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined)
        return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined)
        return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined)
        return false;
    return true;
}
function DigestPaginationMetaDtoFromJSON(json) {
    return DigestPaginationMetaDtoFromJSONTyped(json, false);
}
function DigestPaginationMetaDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pageNo': json['pageNo'],
        'pageSize': json['pageSize'],
        'totalCount': json['totalCount'],
        'totalPages': json['totalPages'],
    };
}
function DigestPaginationMetaDtoToJSON(json) {
    return DigestPaginationMetaDtoToJSONTyped(json, false);
}
function DigestPaginationMetaDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'pageNo': value['pageNo'],
        'pageSize': value['pageSize'],
        'totalCount': value['totalCount'],
        'totalPages': value['totalPages'],
    };
}
